<template>
  <v-menu
    bottom
    left
    offset-y
    origin="top right"
    transition="slide-y-transition"
  >
    <template #activator="{ on }">
      <v-btn dark text v-on="on">
        {{ user.name }}
      </v-btn>
    </template>

    <v-list>
      <v-list-item href="/documents">
        <v-list-item-title>
          Kezdőlap
        </v-list-item-title>
      </v-list-item>
      <Logout />
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Profile",
  computed: {
    ...mapGetters("Auth", {
      user: "loggedInUser"
    })
  }
};
</script>

<style></style>
